import { createRoot } from "@wordpress/element";
import App from "./components/App";

import "@/store/store";
import "@/utils/i18n";

document
	.querySelectorAll(".wp-block-weather-weather-forecast-city")
	.forEach((el) => {
		const root = el.querySelector(".weather-forecast-city__app");
		if (root) {
			createRoot(root).render(<App />);
		}
	});
